import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Card, Grid, Switch } from '@material-ui/core'
import FormTextField from 'components/FormTextField'
import { NumberAutoComplete } from 'components/Select/NumberAutoComplete'
import { isBlank } from 'common/usual'
import { upsertProgramPhasePromise } from 'api/ProgramPhase'

const ProgramPhaseForm = props => {
  const { data, history } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [programPhase, setProgramPhase] = useState({})

  useEffect(() => {
    if (data) setProgramPhase(data)
  }, [data])

  const cancelClicked = useCallback(() => {
    history.goBack()
  }, [history])

  const saveClicked = useCallback(() => {
    setIsSubmitting(true)
    upsertProgramPhasePromise(programPhase)
      .then(() => history.goBack())
      .catch(() => setIsSubmitting(false))
  }, [programPhase, history])

  const isSaveBtnDisabled = useMemo(() => {
    return (
      isBlank(programPhase.title) ||
      isBlank(programPhase.program_id) ||
      isSubmitting
    )
  }, [programPhase.program_id, programPhase.title, isSubmitting])

  const handleChange = useCallback(
    (name, value) => {
      setProgramPhase({ ...programPhase, [name]: value })
    },
    [programPhase]
  )

  return (
    <div className="form-page">
      <div
        className="form-head"
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}>
        <span>
          <Button variant="contained" color="default" onClick={cancelClicked}>
            CANCEL
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            onClick={saveClicked}
            disabled={isSaveBtnDisabled}>
            SAVE
          </Button>
        </span>
      </div>
      <div className="form-elem-container">
        <Card>
          <Grid item xs={12} className="form-card-title">
            <label className="form-card-label">
              {data.id ? 'Edit' : 'Add'} Program Phase
            </label>
            <div>
              <label>Active</label>
              <Switch
                name={'active'}
                checked={Boolean(programPhase.active)}
                onChange={e =>
                  setProgramPhase({ ...programPhase, active: e.target.checked })
                }
              />
            </div>
          </Grid>

          <Grid item xs={12} className="form-card-content">
            <div className="form-input-elem">
              <FormTextField
                name="title"
                label="Title*"
                value={programPhase.title}
                onChange={handleChange}
              />
            </div>
            <div className="form-input-elem">
              <FormTextField
                name="description"
                label="Description"
                value={programPhase.description}
                onChange={handleChange}
              />
            </div>
            <div className="form-input-elem">
              <FormTextField
                name="program_id"
                label="Program Id*"
                value={programPhase.program_id}
                onChange={handleChange}
              />
            </div>
            <div className="form-input-elem">
              <FormTextField
                name="progression_guideline"
                label="Progression Guideline"
                value={programPhase.progression_guideline}
                onChange={handleChange}
                maxLength={220}
              />
            </div>
            <div className="form-input-elem">
              <label className="full-width">Phase</label>
              <NumberAutoComplete
                variant="outlined"
                inputLeft={true}
                name="phase"
                from={1}
                to={10}
                value={programPhase.phase}
                handleSelectChange={phase =>
                  setProgramPhase({ ...programPhase, phase })
                }
              />
            </div>
            <div className="form-input-elem">
              <label className="full-width">Weekly Goal</label>
              <NumberAutoComplete
                variant="outlined"
                inputLeft={true}
                name="weekly_goal"
                from={1}
                to={10}
                value={programPhase.weekly_goal}
                handleSelectChange={weekly_goal =>
                  setProgramPhase({ ...programPhase, weekly_goal })
                }
              />
            </div>
          </Grid>
        </Card>
      </div>
    </div>
  )
}

export default ProgramPhaseForm
